import { TFunction } from 'i18next'

export const CREDIT_TRANSACTION_TYPES = {
    Deposit: 'deposit',
    Applied: 'applied',
    Refund: 'refund',
}

export const CREDIT_TRANSACTION_TYPE = (t: TFunction) => [
    { label: t('deposit'), value: 'deposit', color: 'success' },
    { label: t('applied'), value: 'applied', color: 'warning' },
    { label: t('refund'), value: 'refund', color: 'error' },
]
